const InitialFileManagerContextState = {
  hysteresisSource: null,
  irmSource: null,
  backfieldSource: null,
};

export default InitialFileManagerContextState;
